import { Component, inject } from '@angular/core'
import {
	MatDialogActions,
	MatDialogContent,
	MatDialogRef,
} from '@angular/material/dialog'
import HttpError, { FormErrors } from '@ui/HttpError'
import {
	FormValidationComponent,
	ValidationMessages,
} from '@ui/Components/Form/FormValidation.Component'
import { ReactiveFormsModule, Validators } from '@angular/forms'
import { TextInputComponent } from '@ui/Components/Form/TextInput/TextInput.Component'
import { MatButton } from '@angular/material/button'
import { NgStyle } from '@angular/common'

@Component({
	selector: 'confirm-password-dialog',
	templateUrl: './ConfirmPasswordDialog.Component.html',
	imports: [
		MatDialogContent,
		MatDialogActions,
		TextInputComponent,
		MatButton,
		NgStyle,
		ReactiveFormsModule,
	],
})
export class ConfirmPasswordDialogComponent extends FormValidationComponent {
	public confirmPasswordCallback: (password: string) => Promise<void>

	public formErrors: FormErrors = {
		password: '',
	}

	public validationMessages: ValidationMessages = {
		password: {
			required: 'Password is required',
		},
	}

	private readonly dialogRef: MatDialogRef<ConfirmPasswordDialogComponent>

	constructor() {
		super()
		this.dialogRef = inject(MatDialogRef<ConfirmPasswordDialogComponent>)
	}

	public confirmPassword = async () => {
		this.validateForm()

		if (!this.form.valid) {
			return
		}

		try {
			await this.confirmPasswordCallback(this.form.get('password').value)
			this.closeDialog()
		} catch (error) {
			if (error instanceof HttpError) {
				if (error.isUnprocessableEntity()) {
					this.formErrors = error.handleFormErrors(this.formErrors, '')
					this.markInvalidFields()
				}
				return
			}
			throw error
		}
	}

	public closeDialog = () => {
		this.dialogRef.close()
	}

	protected buildForm() {
		this.form = this.formBuilder.group({
			password: this.formBuilder.control('', [Validators.required]),
		})
	}
}
